$(document).ready(function () {

  $(".custom_main_product_faq .tab_heading_content_wrap").removeClass("active");
  $(".custom_main_product_faq .tab_heading span").removeClass("rotated");

  $(".custom_main_product_faq .tab_heading").click(function () {
    let currentTab = $(this).closest(".tab_heading_content_wrap");

    if (currentTab.hasClass("active")) {
      currentTab.removeClass("active");
      $(this).find("span").removeClass("rotated");
    } else {
      $(".custom_main_product_faq .tab_heading_content_wrap").removeClass("active");
      $(".custom_main_product_faq .tab_heading span").removeClass("rotated");

      currentTab.addClass("active");
      $(this).find("span").addClass("rotated");
    }
  });



$(document).on('click', '.cusotm_dynamic_btn', function (e) {
  e.preventDefault();

  const variantId = $(this).attr('var-id'); // get your custom attribute

  if (!variantId) {
    console.error('Variant ID missing');
    return;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: 1
    },
    success: function () {
      window.location.href = '/checkout'; // direct checkout
    },
    error: function (err) {
      console.error('Add to cart failed:', err);
    }
  });
});



//   // Add On Product to Cart
//   $(document).on("click", ".paired-add-btn", function (e) {
//   e.preventDefault();
//   const pairedVariantId = $(this).attr("variant-id");
//   $btn = $(this);
//  if ($btn.hasClass("added")) {
//     $('.wrapper_data').remove();
//     $btn.removeClass("added").text("Add");

   

//   } else {
//     const html = `
//       <div class="wrapper_data">
//         <input type="hidden" name="items[2][id]" value="${pairedVariantId}">
//         <input type="hidden" name="items[2][quantity]" value="1">
//       </div>
//     `;
//     $('input[name="form_type"]').after(html);
//     $btn.addClass("added").text("Added");
//     setTimeout(function () {
//       $btn.text("Remove");
//     }, 1000);
    
//   }
// });

$(document).on("click", ".paired-add-btn", function (e) {
  e.preventDefault();

  const pairedVariantId = $(this).attr("variant-id");
  const $btn = $(this);

  // find wrapper near this button (important)
  let $wrapper = $btn.closest('.paired-product').find('.wrapper_data');

  if ($btn.hasClass("added")) {

    // REMOVE only this specific one
    $wrapper.remove();

    $btn.removeClass("added").text("Add");

  } else {

    // Prevent duplicate insert
    if ($wrapper.length === 0) {
      const html = `
        <div class="wrapper_data">
          <input type="hidden" name="items[2][id]" value="${pairedVariantId}">
          <input type="hidden" name="items[2][quantity]" value="1">
        </div>
      `;

      $('input[name="form_type"]').after(html);
    }

    $btn.addClass("added").text("Added");

    setTimeout(function () {
      $btn.text("Remove");
    }, 1000);
  }
});

function observeUpcart() {
  const cartContainer = document.querySelector('.upcart-products-section');
  if (!cartContainer) return;

  const observer = new MutationObserver(function () {
    $('.paired-add-btn').each(function () {
      const variantId = $(this).attr('variant-id');
      const stillInCart = $('[id^="' + variantId + ':"]').length > 0;

      if (!stillInCart && $(this).hasClass('added')) {
        $('.wrapper_data').remove();
        $(this).removeClass('added').text('Add');
      }
    });
  });

  observer.observe(cartContainer, { childList: true, subtree: true });
}

// Try on page load
observeUpcart();

// Also try when upcart drawer opens (it renders dynamically)
const bodyObserver = new MutationObserver(function () {
  const cartContainer = document.querySelector('.upcart-products-section');
  if (cartContainer && !cartContainer.dataset.observed) {
    cartContainer.dataset.observed = 'true';
    observeUpcart();
  }
});

bodyObserver.observe(document.body, { childList: true, subtree: true });




 $(document).on("click", ".custom_featured_product .variant_lbl_wrap .custom_size_chart", function(){

    $(".tool-tip-trigger__title").click();

 })









});





function addOnProuctRemoval() {
  $('.wrapper_data').remove();
  $(".paired-add-btn").removeClass("added").text("Add");
}


function waitForUpCart(callback) {
  if (window.upcartSubscribeCartUpdated) {
    callback();
  } else {
    setTimeout(() => waitForUpCart(callback), 200);
  }
}

waitForUpCart(() => {
  window.upcartSubscribeCartUpdated(({ cart }) => {
    const pairedVariantId = parseInt($(".paired-add-btn").attr("variant-id"));

    console.log(pairedVariantId)
    const found = cart.items.find(item => item.variantId == pairedVariantId);

    if (!found) {
      addOnProuctRemoval();
    }
  });
});